import { Link } from 'react-router-dom';
import { ShoppingBasket } from 'lucide-react';
import { useCart } from '@/contexts/CartContext';
import { useLocale } from '@/contexts/LocaleContext';

interface Props { compact?: boolean; }

export function CartIcon({ compact = false }: Props) {
  const { count } = useCart();
  const { locale } = useLocale();
  const isArabic = locale === 'ar';

  const sizeClasses = compact ? 'h-9 w-9' : 'h-10 w-10';

  return (
    <Link
      to="/basket"
      aria-label={isArabic ? 'السلة' : 'Basket'}
      className={`relative inline-flex items-center justify-center rounded-full hover:bg-accent transition-colors ${sizeClasses}`}
    >
      <ShoppingBasket className="w-5 h-5" />
      {count > 0 && (
        <span className="absolute -top-0.5 -end-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-primary text-primary-foreground text-[10px] font-bold flex items-center justify-center shadow-md">
          {count > 99 ? '99+' : count}
        </span>
      )}
    </Link>
  );
}
